/**
 * /settings/usage — W4-12/W4-13, the quota and plan screen.
 *
 * Gated on VITE_BILLING, which is baked at UI build time. With the flag off the
 * route redirects to Settings rather than mounting an empty shell: the tab is
 * not in the nav either, so a direct hit on the URL is the only way to arrive,
 * and landing on a blank page would read as a broken page rather than as a
 * feature that is not on. Same shape as /settings/supervision.
 *
 * VITE_BILLING GATES THE SCREEN, NOT THE CEILINGS. The gateway's three
 * enforcement flags are independent of it and live in the gateway's own
 * environment. Turning this off hides the report; it does not stop a limit.
 * The page says which of the three are honoured, read from the server.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

import { env } from '../../../env';

export const Route = createFileRoute('/_authenticated/settings/usage')({
  beforeLoad: () => {
    if (!env.VITE_BILLING) {
      throw redirect({ to: '/settings/profile', replace: true });
    }
  },
});
